import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "\n      h-80\n      bg-amff-teal\n      w-full\n      py-10\n      flex flex-col\n      items-center\n      justify-center\n    " }
const _hoisted_2 = { class: "\n        max-w-container\n        px-container\n        font-display\n        text-amff-black text-center\n        tracking-widest\n        flex flex-col\n        items-center\n        justify-center\n      " }
const _hoisted_3 = { class: "mb-14" }
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" © Atlàntida Mallorca Film Fest 2023 ")
const _hoisted_5 = { class: "block md:inline text-base mt-4 md:mt-0" }
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "mx-3 hidden md:inline" }, "|", -1)
const _hoisted_7 = {
  href: "mailto:hola@atlantidafilmfest.es",
  target: "_blank",
  class: "\n              lg:hover:bg-amff-black\n              lg:hover:text-amff-teal\n              block\n              md:inline\n            "
}
const _hoisted_8 = { class: "text-xs flex flex-col md:flex-row items-center justify-center" }
const _hoisted_9 = { class: "mr-0 md:mr-3 mb-4 md:mb-0" }
const _hoisted_10 = {
  href: "https://www.filmin.es",
  target: "_blank"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FilminLogo = _resolveComponent("FilminLogo")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode("div", _hoisted_5, [
          _hoisted_6,
          _createVNode("a", _hoisted_7, _toDisplayString(_ctx.$t("footer.contact")), 1)
        ])
      ]),
      _createVNode("div", _hoisted_8, [
        _createVNode("div", _hoisted_9, _toDisplayString(_ctx.$t("footer.proyect_of")), 1),
        _createVNode("a", _hoisted_10, [
          _createVNode(_component_FilminLogo, {
            class: "h-5 mx-auto",
            fill: "currentColor"
          })
        ])
      ])
    ])
  ]))
}